<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('influenceFactors.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="factor-desc-box">
                <div class="factor-desc-item">
                    <div class="factor-bar factor-bar0"></div>
                    <div class="factor-bar-title">{{ $t('influenceFactors.helps') }}</div>
                </div>
                <div class="factor-desc-split"></div>
                <div class="factor-desc-item">
                    <div class="factor-bar factor-bar1"></div>
                    <div class="factor-bar-title">{{ $t('influenceFactors.hurts') }}</div>
                </div>
            </div>
            <div class="factor-list-box">
                <div class="factor-item-box">
                    <div class="factor-title-line">
                        <div class="factor-title">RESTING HR</div>
                        <div class="factor-value factor-value-add">+31%</div>
                    </div>
                    <div class="factor-progress">
                        <img class="factor-progress-bg" src="@/assets/theme/light/status/25influenceFactors/01bg.svg">
                        <div class="factor-progress-value factor-bar0" style="width: 115px"></div>
                    </div>
                </div>

                <div class="factor-item-box">
                    <div class="factor-title-line">
                        <div class="factor-title">SKIN TEMPERATURE</div>
                        <div class="factor-value factor-value-reduce">-5%</div>
                    </div>
                    <div class="factor-progress">
                        <img class="factor-progress-bg" src="@/assets/theme/light/status/25influenceFactors/01bg.svg">
                        <div class="factor-progress-value factor-bar1" style="width: 115px"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: '25InfluenceFactors',
    data() {
        return {
            theme: 'light',
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme
        }
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
    }
}
</script>

<style scoped>
.factor-bar {
    width: 15px;
    height: 8px;
    border-radius: 2px 2px 2px 2px;
    margin-right: 6px;
}

.factor-bar0 {
    background: var(--chart-color-1);
}

.factor-bar1 {
    background: var(--chart-color-5);
}

.factor-bar-title {
    font-size: 11px;
    color: var(--text-color-2);
}

.factor-desc-box {
    display: flex;
    justify-content: center;
}

.factor-desc-item {
    display: flex;
    align-items: center;
}

.factor-desc-split {
    width: 28px;
}

.factor-list-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 10px;
    margin: 16px auto;
    padding: 16px 0;
}

.factor-item-box {
    width: 320px;
    margin: 0 auto 24px;
}

.factor-title-line {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 13px;
    color: var(--text-color-1);
}

.factor-value-add {
    color: var(--chart-color-1);
}

.factor-value-reduce {
    color: var(--chart-color-5);
}

.factor-progress {
    width: 320px;
    height: 8px;
    position: relative;
    border-radius: 2px;
}

.factor-progress-bg {
    position: absolute;
    left: 0;
    top: 0;
}

.factor-progress-value {
    height: 8px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 2px;
}

.factor-item-box:last-child {
    margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/status/25InfluenceFactors.vue